import React from 'react';
import { Box, Tooltip } from '@mui/material';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import { formatDelta } from '../../utils/format';
import { tokens } from '../../theme';

// Change against the previous period of the same length. When there is no comparable data
// (incomplete history, zero base) it says so instead of showing a made-up percentage.
const DeltaBadge = ({ value, unit = '%', invert = false, reason, compact = false, suffix }) => {
  if (value === null || value === undefined) {
    const text = reason === 'no_history' ? 'нет данных за прошлый период' : 'сравнение недоступно';
    return (
      <Tooltip title={reason === 'no_history'
        ? 'Для сравнения нужен загруженный предыдущий период той же длины'
        : 'Сравнение невозможно: в прошлом периоде значение было нулевым или данных нет'}>
        <Box component="span" tabIndex={0} sx={{ color: tokens.inkMuted, fontSize: compact ? '0.8125rem' : '0.875rem', whiteSpace: 'nowrap' }}>
          {compact ? '—' : text}
        </Box>
      </Tooltip>
    );
  }
  const n = Number(value);
  const good = invert ? n < 0 : n > 0;
  const bad = invert ? n > 0 : n < 0;
  const color = good ? tokens.success : bad ? tokens.error : tokens.inkSoft;
  const Icon = n > 0 ? ArrowUpwardRoundedIcon : n < 0 ? ArrowDownwardRoundedIcon : null;
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, color, fontWeight: 600, fontSize: compact ? '0.8125rem' : '0.9375rem', whiteSpace: 'nowrap' }}>
      {Icon && <Icon sx={{ fontSize: compact ? 14 : 16 }} aria-hidden />}
      {formatDelta(n, unit)}
      {suffix && <Box component="span" sx={{ color: tokens.inkSoft, fontWeight: 500, ml: 0.5 }}>{suffix}</Box>}
    </Box>
  );
};

export default DeltaBadge;
